module.exports = san.defineComponent({
    template: require('../views/IntelligentGeneration/doc-jt.html'),
    initData: function () {
        return {
            explain: 0,
            showAlert: false,
            isAlert: false,
            picker: {
                language: 'zh',
                format: 'yyyy-MM-dd',
            },
            EvidenceList: [{
                loanDate1: '',
                loanDate2: '',
                loanDate3: '',
                lenderName: '',
                loanAmount: '',
                amountInWords: '',
                paymenMethod: '',
                interestRate: '',
                interest: '',
                principalAndInterest: '',
                interestCard: '',
                purpose: '',
                overdue: '',
                rateType: '1',
                rateType2: '1'
            }],//事实说明
            ifCreate: false,
            uid: '',
            id: 8,
            tipMessage: '',
            seedFail: true,//邮箱发送失败
            email: '',
            emailAddress: '',
            result: {},
            re: [],
            qtre: [],
            qrcodeUrl2: '',
            ifspouse: 1,//是否需要配偶签名,
            message:'发送中...'
        };
    },
    components: {},
    created: function () {
        var list = this.data.get('EvidenceList');
        list[0].loanDate1 = this.createDate();
        list[0].loanDate2 = this.createDate();
        list[0].loanDate3 = this.createDate();
        this.data.set('EvidenceList',list);
        this.data.set('ifCreate',false);
        this.data.set('showAlert',false);
    },
    attached: function(){
        var me=this;
        $('#mydatepicker1').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            var list = me.data.get('EvidenceList');
            list[0].loanDate1 = e.date;
            me.data.set('EvidenceList',list);
            me.InterestCalculation();
        }); //初始化日期选择器
        $('#mydatepicker2').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            var list = me.data.get('EvidenceList');
            list[0].loanDate2 = e.date;
            me.data.set('EvidenceList',list);
            me.InterestCalculation();
        }); //初始化日期选择器
        $('#mydatepicker3').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            var list = me.data.get('EvidenceList');
            list[0].loanDate3 = e.date;
            me.data.set('EvidenceList',list);
        }); //初始化日期选择器
    },
    hide: function () {
        this.data.set('explain',0);
    },
    createDate: function () {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentDate = year + seperator1 + month + seperator1 + strDate;
        return currentDate;
    },
    createWs: function () {
        var me = this;
        var returnFlag = true;
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        this.data.get('EvidenceList').map(function (element, index, arr) {
            if (element.lenderName == '') {
                me.dispatch('showAlert',{title:'提示',msg:"出借人姓名不能为空"});
                returnFlag = false;
                return;
            }
            if (element.loanAmount == '') {
                me.dispatch('showAlert',{title:'提示',msg:"借款金额不能为空"});
                returnFlag = false;
                return;
            }
            if (element.amountInWords == '') {
                me.dispatch('showAlert',{title:'提示',msg:"大写借款金额不能为空"});
                returnFlag = false;
                return;
            }
            if (element.paymenMethod == '') {
                me.dispatch('showAlert',{title:'提示',msg:"支付方式不能为空"});
                returnFlag = false;
                return;
            }
            if (element.interestRate == '') {
                me.dispatch('showAlert',{title:'提示',msg:"约定利率不能为空"});
                returnFlag = false;
                return;
            }
            if (element.principalAndInterest == '') {
                me.dispatch('showAlert',{title:'提示',msg:"本息不能为空"});
                returnFlag = false;
                return;
            }
            if (element.purpose == '') {
                me.dispatch('showAlert',{title:'提示',msg:"借款用途不能为空"});
                returnFlag = false;
                return;
            }
            if (element.overdue == '') {
                me.dispatch('showAlert',{title:'提示',msg:"逾期利息标准不能为空"});
                returnFlag = false;
                return;
            }
            if (element.interestCard == '') {
                me.dispatch('showAlert',{title:'提示',msg:"借款人身份证号不能为空"});
                returnFlag = false;
                return;
            }
            if (reg.test(element.interestCard) === false) {
                me.dispatch('showAlert',{title:'提示',msg:"借款人身份证号不合法"});
                returnFlag = false;
                return;
            }
        });
        if (!returnFlag) {
            return;
        }
        var result2 = {
            evidenceList: this.data.get('EvidenceList'),
            consultType: 3
        };
        var result = JSON.parse(JSON.stringify(result2));
        var a = /^(\d{4})-(\d{2})-(\d{2})$/;
        result.evidenceList.map(function (element, index, arr) {
            if (element.loanDate1 != '') {
                var date = new Date(element.loanDate1.split('T')[0].replace(/-/g, '/'));
                element.loanDate1 = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            }
            if (element.loanDate2 != '') {
                var date = new Date(element.loanDate2.split('T')[0].replace(/-/g, '/'));
                element.loanDate2 = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            }
            if (element.loanDate3 != '') {
                var date = new Date(element.loanDate3.split('T')[0].replace(/-/g, '/'));
                element.loanDate3 = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            }
        });
        this.data.set('result',result);
        this.el.scrollTop = 0;
        this.data.set('ifCreate',true);
        san.nextTick(function () {
            me.getUID();
        });
    },
    getUID: function () {
        var res = document.getElementById('znwsResult').innerHTML;
        var me = this;
        this.data.set('message','加载中...');
        this.data.set('showLoading',true);
        var params2 = {
            consultType: 3,
            css: '.znws{' +
                'font-family: 仿宋;' +
                '}' +
                '.application-title{' +
                'margin-bottom: 40px;' +
                '}' +
                '.application-title h2 {' +
                'text-align: center;' +
                'font-size: 18pt;' +
                'font-weight: 600;' +
                'margin-bottom: 20px;' +
                'line-height: 150%;' +
                '}' +
                '.result-box {' +
                'font-size: 14pt;' +
                'line-height: 150%;' +
                '}' +
                '.result-box h3 {' +
                'font-weight: bold;' +
                'font-size: 14pt;' +
                'text-indent: 2em;' +
                '}' +
                '.result-box h5 {' +
                'font-size: 12pt;' +
                'margin: 30px 0;' +
                'color: #666;' +
                'font-weight: normal;' +
                '}' +
                '.result-box p {' +
                'text-indent: 2em;' +
                'font-size: 14pt;' +
                '}' +
                '.applicant{' +
                'text-align: right;' +
                'margin-right: 150px;' +
                '}' +
                '.applicant span{' +
                'font-size: 12pt;' +
                '}' +
                '.other-evidence {' +
                'margin: 40px 0;' +
                '}' +
                '.other-evidence p {' +
                'font-size: 14pt;' +
                'text-indent: 2em;' +
                'line-height: 150%;' +
                '}' +
                '.other-evidence h2 {' +
                'font-size: 14pt;' +
                'text-align: center;' +
                'font-weight: 600;' +
                '}' +
                '.other-evidence h3 {' +
                'font-size: 12pt;' +
                'text-align: center;' +
                'color: #a5a5a5;' +
                'text-indent: 2em;' +
                '}',
            body: res,
        };
        Api("post", "/api/writ/v2/getUid", JSON.stringify(params2)).then(function (response) {
            me.data.set('showLoading',false);
            me.data.set('uid',response.uid);
            
            Api("get", `/api/writ/law/document?uid=${response.uid}`).then(function (res) {
                const baseUrl = res.url
                me.createQrcode2(baseUrl);
            });
            me.dispatch('goTop');
        });
    },
    createQrcode2: function (baseUrl) {
        var me = this;
        // 动态生成二维码
        document.getElementById('qrcode2').innerHTML='';
        window.qrcode = new QRCode('qrcode2', {
            text: baseUrl,
            width: 160,
            height: 160
        });
    },
    mail: function () {
        this.data.set('showAlert',true);
    },
    cancel: function () {
        this.data.set('showAlert',false);
    },
    InterestCalculation: function () {
        var me = this;
        var list = this.data.get('EvidenceList');
        var date1 = new Date(list[0].loanDate1.replace(/-/g, '/')).getTime();
        var date2 = new Date(list[0].loanDate2.replace(/-/g, '/')).getTime();
        if (!!list[0].loanAmount && !!list[0].interestRate) {
            if(list[0].rateType == 1){
                list[0].interest = parseFloat((Number(list[0].loanAmount) * (date2 - date1) / 1000 / 3600 / 24 / 365 * Number(list[0].interestRate) / 100).toFixed(2));
                list[0].principalAndInterest = parseFloat((list[0].interest + parseInt(list[0].loanAmount)).toFixed(2));
            }else {
                list[0].interest = parseFloat((list[0].loanAmount * (date2 - date1) / 1000 / 3600 / 24 / 365 * 12 * list[0].interestRate / 100).toFixed(2));
                list[0].principalAndInterest = parseFloat((list[0].interest + parseInt(list[0].loanAmount)).toFixed(2));
            }
            me.data.set('EvidenceList[0].interest','');
            me.data.set('EvidenceList[0].principalAndInterest','');
            san.nextTick(function () {
                me.data.set('EvidenceList[0].interest',list[0].interest);
                me.data.set('EvidenceList[0].principalAndInterest',list[0].principalAndInterest);
            });
        }
    },
    DX: function () {
        this.InterestCalculation();
        var n = this.data.get('EvidenceList')[0].loanAmount;
        var m,me = this;
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
            return "数据非法";
        var unit = "千百拾亿千百拾万千百拾元角分", str = "";
        n += "00";
        var p = n.indexOf('.');
        if (p >= 0)
            n = n.substring(0, p) + n.substr(p + 1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i = 0; i < n.length; i++)
            str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
        m = str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
        var list = me.data.get('EvidenceList');
        list.forEach(function (item,index) {
            if(index === 0){
                item.amountInWords = m;
            }
        });
        me.data.set('EvidenceList[0].amountInWords','');
        san.nextTick(function () {
            me.data.set('EvidenceList[0].amountInWords',list[0].amountInWords);
        });
    },
    getBirthdayFromIdCard: function (idCard, index, type) {
        if (idCard != '') {
            var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (reg.test(idCard) === false) {
                this.dispatch('showAlert',{title:'提示',msg:"身份证输入不合法"});
                return;
            }
        }
    },
    modalSure: function () {
        var me = this;
        this.data.set('showFlag', '1');
        if (this.data.get('email') == '') {
            this.data.set('tipMessage', '邮箱不能为空');
            this.data.set('seedFail', true);
            return;
        }
        var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
        if (!reg.test(this.data.get('email'))) {
            this.data.set('tipMessage', '邮箱格式不正确');
            this.data.set('seedFail', true);
            return;
        }
        this.data.set('showAlert', false);
        san.nextTick(function () {
            me.data.set('message','发送中...');
            me.data.set('showLoading', true);
        });
        var data;
        var type;
        if (!!this.data.get('ifCreate')) {
            type = 5;
            data = {'uid': me.data.get('uid'), 'toAddress': me.data.get('email')};
            Api("post", "/api/writ/v2/sendmail/" + type, JSON.stringify(data)).then(function (response) {
                window.NewLog._saveLog("SMART_WORD-PRIVATE_LEND", "法律文书-借条", 8, "借条", "SEND_MAIL");
                me.data.set('showLoading', false);
                if (response.code == 0) {
                    me.dispatch('showAlert',{title:'提示',msg:"发送成功"});
                } else {
                    me.dispatch('showAlert',{title:'提示',msg:response.msg});
                }
            });
        }
    },
    showExplain: function(type){
        this.data.set('explain',type);
    },
    revise: function(){
        this.data.set('ifCreate',false);
    },
    onSpouse: function(){
        this.data.set('ifspouse',1);
    },
    offSpouse: function(){
        this.data.set('ifspouse',0);
    },
    hideLoad: function(){
        this.data.set('showLoading', false);
    },
    messages: {}
});



//////////////////
// WEBPACK FOOTER
// ./src/components/doc-jt.js
// module id = 366
// module chunks = 1